<footer class="jobguru-footer-area">
  <div class="footer-top section_50">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="single-footer-widget">
            <div class="footer-logo">
              <a href="index-2.html">
                <img
                  src="./assets/dist/img/logo/telonelogo.png"
                  alt="jobguru logo"
                />
              </a>
            </div>
            <!-- <p>Aliquip exa consequat dui aut repahend vouptate elit cilum fugiat pariatur lorem dolor cit amet consecter adipisic elit sea vena eiusmod nulla</p> -->
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget">
            <h3>Follow US</h3>
            <div class="latest-post-footer clearfix">
              <ul class="footer-social">
                <li>
                  <a href="https://www.facebook.com/TelOneZW/" class="fb"
                    ><i class="fa fa-facebook"></i
                  ></a>
                </li>
                <li>
                  <a href="https://twitter.com/TelOneZW" class="twitter"
                    ><i class="fa fa-twitter"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://zw.linkedin.com/company/telone-zimbabwe-pvt-ltd"
                    class="linkedin"
                    ><i class="fa fa-linkedin"></i
                  ></a>
                </li>
                <!-- <li><a href="#" class="skype"><i class="fa fa-skype"></i></a></li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="single-footer-widget footer-contact">
            <h3>Contact Info</h3>
            <p>
              <i class="fa fa-map-marker"></i>Runhare House, 107 Kwame Nkrumah
              Avenue
            </p>
            <p><i class="fa fa-phone"></i> +263 24 279 8111</p>
            <p>
              <i class="fa fa-envelope-o"></i> careerssupport&#64;telone.co.zw
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-copyright">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="copyright-left">
            <p class="my-4 text-white text-center text-muted charter">
              Learn more about our mission and values in
              <a routerLink="/charter">Our TelOne Charter.</a>
            </p>
            <p>
              All Rights Reserved &copy; Copyright {{ currentYear }} TelOne. All
              rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- Feedback Popup Here -->
<!-- <div *ngIf="feedbackActive">
  <app-feedback-popup></app-feedback-popup>
</div> -->


 <!-- Complaints Popup Here -->

<!-- <div *ngIf="complaintActive">
  <app-complaints></app-complaints>
 </div> -->


